/*

 SugarWOD Cloud Code

 utilities.js

 */
/* eslint-disable complexity */
// TODO: Decouple - This file, it can't be loaded until after sw_models.js wherever its required

const path = require("path");

const _ = require("underscore"),
    moment = require("moment"),
    valid_url = require("valid-url");

// NOTE: Updates for SUGWOD-7558 after upgrading to Parse-server 6.x.x
// const firebaseConfigJSON = require("../firebase.js");

const _sw_constants = require("./sw-constants");
const { dateFormats, ACL_ROLE_PERMISSIONS } = require("./sw-constants");

// Date utilities

/*
 "DateIntegers" are used often in SugarWOD to represent
 a calendar date irrespective of timezone or timestamp

 This is useful when saying "This workout is scheduled for
 "May 4, 2019" and have that be the same date everywhere in the world.

 A "Date Int" is represented as:
 Oct 27, 1967 -> 19671027
 Jan 2, 2001  -> 20010102
 */

// date conversions
const dateAsInteger = function (date) {
    return momentAsInteger(moment(date));
};
exports.dateAsIntegerIfDefined = function (date) {
    return date ? dateAsInteger(date) : null;
};
exports.integerAsDate = function (dateInt) {
    return integerAsMoment(dateInt).toDate();
};
const momentAsInteger = (mom) => {
    return parseInt(mom.format(dateFormats.asInteger), 10);
};
const integerAsMoment = (dateInt) => {
    return moment(dateInt, dateFormats.asInteger);
};

// date helpers
exports.dateIntegerToday = function () {
    return dateAsInteger(new Date());
};
exports.dateAsYYYYMMDD = function (d) {
    return moment(d).format("YYYY-MM-DD");
};
exports.dateAsYYYYMMMDD = function (d) {
    return moment(d).format("YYYY-MMM-DD").toUpperCase();
};

exports.daysBetweenDateIntegers = function (dateFromInt, dateToInt) {
    if (dateFromInt === dateToInt) {
        return 0;
    }

    const fromDate = integerAsMoment(dateFromInt);
    const toDate = integerAsMoment(dateToInt);

    return toDate.diff(fromDate, "days");
};
exports.incrementDateInteger = function (dateInt, days) {
    return momentAsInteger(integerAsMoment(dateInt).add(days, "days"));
};

const formatDateFromInt = function (dateInt) {
    const dateString = dateInt.toString().padStart(8, "0");
    const date = moment(dateString, "YYYYMMDD");
    const formattedDate = date.format("MMMM D, YYYY");
    return formattedDate;
};

// https://www.ranks.nl/stopwords
const INDEX_STOP_WORDS = [
    "",
    "a",
    "about",
    "above",
    "after",
    "again",
    "against",
    "all",
    "am",
    "an",
    "and",
    "any",
    "are",
    "aren't",
    "as",
    "at",
    "be",
    "because",
    "been",
    "before",
    "being",
    "below",
    "between",
    "both",
    "but",
    "by",
    "can't",
    "cannot",
    "could",
    "couldn't",
    "did",
    "didn't",
    "do",
    "does",
    "doesn't",
    "doing",
    "don't",
    "down",
    "during",
    "each",
    "few",
    "for",
    "from",
    "further",
    "had",
    "hadn't",
    "has",
    "hasn't",
    "have",
    "haven't",
    "having",
    "he",
    "he'd",
    "he'll",
    "he's",
    "her",
    "here",
    "here's",
    "hers",
    "herself",
    "him",
    "himself",
    "his",
    "how",
    "how's",
    "i",
    "i'd",
    "i'll",
    "i'm",
    "i've",
    "if",
    "in",
    "into",
    "is",
    "isn't",
    "it",
    "it's",
    "its",
    "itself",
    "let's",
    "me",
    "more",
    "most",
    "mustn't",
    "my",
    "myself",
    "no",
    "nor",
    "not",
    "of",
    "off",
    "on",
    "once",
    "only",
    "or",
    "other",
    "ought",
    "our",
    "ours",
    "ourselves",
    "out",
    "over",
    "own",
    "same",
    "shan't",
    "she",
    "she'd",
    "she'll",
    "she's",
    "should",
    "shouldn't",
    "so",
    "some",
    "such",
    "than",
    "that",
    "that's",
    "the",
    "their",
    "theirs",
    "them",
    "themselves",
    "then",
    "there",
    "there's",
    "these",
    "they",
    "they'd",
    "they'll",
    "they're",
    "they've",
    "this",
    "those",
    "through",
    "to",
    "too",
    "under",
    "until",
    "up",
    "very",
    "was",
    "wasn't",
    "we",
    "we'd",
    "we'll",
    "we're",
    "we've",
    "were",
    "weren't",
    "what",
    "what's",
    "when",
    "when's",
    "where",
    "where's",
    "which",
    "while",
    "who",
    "who's",
    "whom",
    "why",
    "why's",
    "with",
    "won't",
    "would",
    "wouldn't",
    "you",
    "you'd",
    "you'll",
    "you're",
    "you've",
    "your",
    "yours",
    "yourself",
    "yourselves",
];

// Array utilities
exports.searchTermArrayFromString = function (str = "") {
    const arrayOfStrings = _.uniq(
        // clean up, split and sort this string
        str

            // remove weird non-indexable characters
            // https://stackoverflow.com/questions/3780696/javascript-string-replace-with-regex-to-strip-off-illegal-characters
            .replace(/[[\]|:&#\-^.`'"*;$%@"<>()+,]/g, "")

            // remove emojis and such
            // https://stackoverflow.com/questions/10992921/how-to-remove-emoji-code-using-javascript
            .replace(
                /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
                ""
            )

            // collapse consecutive spaces
            .replace(/\s+/g, " ")

            // standardize to lowercase
            .toLowerCase()

            // split on spaces to get array of words
            .split(" ")

            .sort(),

        // isSorted = true
        true,

        // provide a transform for the uniq
        function (s) {
            // remove empty or single character "words", truncate at 24 chars.
            return s.length < 2 ? "" : s.substr(0, 24);
        }
    );

    // remove stop words from the array...
    return _.difference(arrayOfStrings, INDEX_STOP_WORDS);
};
exports.arraysHaveSameItems = function (a, b) {
    // does not consider ordering
    return a.length === b.length && a.length === _.intersection(a, b).length;
};

exports.userIsFrozen = function (user) {
    return user && user.isFrozen();
};

// Email // TODO: Investigate how we can change to this
// const createBase64Attachment = (data) => {
//     return Buffer.from(data, "utf8").toString("base64");
// };

const createBase64Attachment = function (contents) {
    var buf = new Buffer(contents);
    var base64Attachment = buf.toString("base64");
    return base64Attachment;
};

exports.isValidEmail = function (email) {
    // http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return isDefined(email) && re.test(email);
};

// Display
const numberWithCommas = (num) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

exports.percentString = function (prev, cur) {
    var percent = (((cur - prev) / prev).toFixed(2) * 100).toFixed(0);

    if (percent == 0) return "--";

    return (percent > 0 ? "+" : "") + percent + "%";
};

// String
exports.replaceQuotes = function (str) {
    // replace double-quotes with 2x double-quotes
    // remove single-quotes
    return str.replace(/"/g, '""').replace(/'/g, "");
};
exports.replaceLineReturns = function (str) {
    // remove all new lines, returns, etc.
    return str.replace(/(\r\n|\n|\r)/gm, "");
};
exports.replaceQuotesAndLineReturns = function (str) {
    return exports.replaceQuotes(exports.replaceLineReturns(str.toString()));
};
const withHttpIfNecessary = (url) => {
    // prepend with "http://" if not already present
    if (!(url && url.length)) return null;
    return url.indexOf("http") === -1 ? "http://" + url : url;
};

// JSON
exports.jsonStringifyApostropheReplacer = function (key, value) {
    // replace single-quotes \'
    // replace double-quotes \"
    // replace line returns

    // these chars can screw up a jsonp response when the browser tries to execute the callback function

    if (typeof value === "string") {
        return value.replace(/'/g, "'").replace(/"/g, '"');
    }
    return value;
};

exports.jsFriendlyJSONStringify = function (s) {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify
    return JSON.stringify(s, exports.jsonStringifyApostropheReplacer)
        .replace(/\u2028/g, "\\u2028")
        .replace(/\u2029/g, "\\u2029");
};

// Metric <-> Imperial conversions
exports.toLbs = function (kgs) {
    // converts to nearest integer lbs
    return Math.round(kgs * 2.20462);
};

exports.toKgs = function (lbs) {
    // converts to nearest 0.1 kg
    var kgs = lbs / 2.20462;
    return parseFloat((Math.round(kgs * 10) / 10).toFixed(1));
};

// Asserts
// Asserts throw errors. These should be used inside a .then() func of a Promise and caught in the .catch()
const assertTrue = (aBoolean, assertFailMessage, errCode) => {
    // all other asserts should in turn call "assertTrue" with a boolean statement
    if (aBoolean !== true) {
        console.error(
            'assert failed: "' +
                (assertFailMessage || "Assert failed.") +
                '" error code: "' +
                (errCode || _sw_constants.ERROR.ASSERT_FAIL) +
                '"'
        );
        throw new Parse.Error(
            errCode || _sw_constants.ERROR.ASSERT_FAIL,
            assertFailMessage || "Assert failed."
        );
    }
};

const assertFalse = function (aBoolean, assertFailMessage, errCode) {
    return assertTrue(!aBoolean, assertFailMessage, errCode);
};

// asserts: existence
const assertDefined = (anObject, errMsg, errCode) => {
    assertTrue(isDefined(anObject), errMsg || "Object not defined.", errCode);
};
const assertAllDefined = function (arrayObj, failMessage, errCode) {
    _.each(arrayObj, function (obj) {
        assertDefined(obj, failMessage || "Objects not defined.", errCode);
    });
};

// asserts: type
const assertType_Object = (maybeAnObject, failMessage, errCode) => {
    assertTrue(typeof maybeAnObject === "object", failMessage, errCode);
};
const assertType_Array = (aThing, failMessage, errCode) => {
    assertTrue(Array.isArray(aThing), failMessage, errCode);
};
const assertType_String = (aThing, failMessage, errCode) => {
    assertTrue(typeof aThing === "string", failMessage, errCode);
};
exports.assertType_Number = function (aThing, failMessage, errCode) {
    assertTrue(typeof aThing === "number", failMessage, errCode);
};
exports.assertType_Integer = function (aThing, failMessage, errCode) {
    exports.assertType_Number(aThing, failMessage, errCode);
    assertTrue(Number.isInteger(aThing), failMessage, errCode);
};

exports.assertType_URI = function (aThing, failMessage, errCode) {
    assertType_String(aThing, failMessage, errCode);
    assertDefined(valid_url.isWebUri(aThing), failMessage, errCode);
};
exports.assertType_HTTPS_URI = function (aThing, failMessage, errCode) {
    assertType_String(aThing, failMessage, errCode);
    assertDefined(valid_url.isHttpsUri(aThing), failMessage, errCode);
};

// asserts: models
exports.assertDoesNotBelongToHQ = function (obj1, errMsg, errCode) {
    // assert that the object is not in the HQ (by comparing affiliate IDs)
    // must have an 'affiliate' attribute
    // currently applies to User, Athlete, ScheduledWorkout, WorkoutResult, Track, LibraryWorkout, maybe others...
    assertDefined(obj1);
    assertTrue(
        obj1.get("affiliate").id !== _sw_constants.AFFILIATE_ID_HQ,
        errMsg || "Permission denied: can not modify CrossFit.com objects.",
        errCode || _sw_constants.ERROR.NOT_PERMITTED_WITH_HQ
    );
};
exports.assertIsNotHQ = function (aff, errMsg, errCode) {
    assertDefined(aff, errMsg, errCode);
    assertTrue(
        aff.id !== _sw_constants.AFFILIATE_ID_HQ,
        errMsg || "Permission denied: can not modify CrossFit.com objects.",
        errCode || _sw_constants.ERROR.NOT_PERMITTED_WITH_HQ
    );
};
exports.assertUserIsNotFrozen = function (user, errMsg, errCode) {
    assertTrue(
        !exports.userIsFrozen(user),
        errMsg || "Access denied.",
        errCode
    );
};

const assertIsValidObjectId = (maybeID, errMsg, errCode) => {
    assertType_String(maybeID, errMsg, errCode);
    assertTrue(
        maybeID.length === _sw_constants.PARSE_OBJECT_ID_LENGTH,
        errMsg,
        errCode
    );
};
exports.assertIsArrayOfValidObjectIds = function (
    maybeArrayOfIDs,
    errMsg,
    errCode
) {
    assertType_Array(maybeArrayOfIDs, errMsg, errCode);
    _.each(maybeArrayOfIDs, function (maybeID) {
        assertIsValidObjectId(maybeID, errMsg, errCode);
    });
};

exports.assertIsValidEmail = function (email, failMessage, errCode) {
    assertTrue(exports.isValidEmail(email), failMessage, errCode);
};

exports.assertIsValidDate = function (year, month, day, errMsg, errCode) {
    if (typeof month == "string") {
        month = moment.months().indexOf(month);
    }
    const dateObj = moment({
        year,
        month,
        day,
    });
    assertTrue(dateObj.isValid(), errMsg, errCode);
};

// cloud code responses and errors
// TODO: Evaluate if there's a reason to keep this.
exports.cloudFunctionErrorResponse = function (
    request,
    response,
    error,
    preferredErrorMessages
) {
    // swizzle in a better message, if provided
    exports.preferredParseErrorMessage(error, preferredErrorMessages);

    // respond with the error.
    throw "[SugarWOD] " + error.message;
};
exports.preferredParseErrorMessage = function (error, messages) {
    // override parse messages with context-specific messages
    // based on the error code

    // messages is:
    //   {
    //      Parse.Error.OBJECT_NOT_FOUND: 'alternate error message'
    //   }

    if (!messages) {
        return;
    }

    // if an error message has been provided for this code, then use it!
    if (messages[error.code]) {
        error.message = messages[error.code];
    }

    return;
};

// cookies
exports.parseCookie = function (req, cookieKey) {
    var info = null;
    if (isDefined(req.signedCookies)) {
        try {
            info = JSON.parse(req.signedCookies[cookieKey]);
        } catch (e) {
            // no cookie found (or error parsing cookie)
        }
    }
    return info;
};

// Errors
exports.stringForParseError = function (error) {
    return "Error: " + error.code + " - " + error.message;
};
exports.promiseError = function (errMsg) {
    return Promise.reject(new Error(errMsg));
};

// EJS Utilities
exports.pageTitle = function (title) {
    return title + " : SugarWOD";
};

// mapping utilities
const getIdIfDefined = (pfobj) => (pfobj ? pfobj.id : null);

const getURLIfDefined = function (pffile) {
    return pffile
        ? pffile
              .url()
              .replace(
                  "http://files.parsetfss.com",
                  "https://files.parsetfss.com"
              )
        : null;
};
exports.emptyStringIfNotDefined = function (obj) {
    return obj ? obj : "";
};
exports.pfosAsJSON = function (arrayOfPFOs, options) {
    // TB* class must have implemented asJSON()
    return _.map(arrayOfPFOs || [], function (pfo) {
        return pfo.asJSON(options);
    });
};
const asJSONIfDefined = (pfo, options) => (pfo ? pfo.asJSON(options) : {});

exports.asJSONIfDefinedOrNull = function (pfo, options) {
    return pfo ? pfo.asJSON(options) : null;
};

// PATCHING MODEL OBJECTS
exports.patchModelObject = function (pfo, newValues, options = {}) {
    // will mutate the pfo
    // will only modify properties that have changed.
    // returns true if pfo is "dirty"
    // the model class of the pfo must implement patchableAttributeDefs

    var isDirty = false;
    var _currentValue = null,
        _newValue = null;

    _.each(pfo.patchableAttributeDefs(options), function (attrDef) {
        // is there a value for this key in the body?
        if (
            Object.prototype.hasOwnProperty.call(newValues, attrDef.attribute)
        ) {
            if (attrDef.getter && attrDef.setter) {
                // is the new value different than the old value?
                _currentValue = attrDef.getter.call(pfo);
                _newValue = newValues[attrDef.attribute];

                // depending on the attributeType, there are different ways of considering equivalent
                var valueChanged = false;
                var attributeType = attrDef.attributeType || "atomic";
                switch (attributeType) {
                    case "array":
                        valueChanged = !exports.arraysHaveSameItems(
                            _currentValue,
                            _newValue
                        );
                        break;
                    case "object":
                        valueChanged = !_.isEqual(_currentValue, _newValue);
                        break;
                    case "atomic":
                    default:
                        valueChanged = _currentValue !== _newValue;
                        break;
                }

                if (valueChanged) {
                    // is this property a pointer to another model instance?
                    if (attrDef.modelClass) {
                        // either set to an object or unset
                        if (
                            isDefined(_newValue) &&
                            _newValue.length ===
                                _sw_constants.PARSE_OBJECT_ID_LENGTH
                        ) {
                            var stubPfo =
                                attrDef.modelClass.createWithoutData(_newValue);
                            _newValue = stubPfo;
                        } else {
                            _newValue = null;
                        }
                    }

                    // it has changed, set the new value (mutate pfo)
                    attrDef.setter.call(pfo, _newValue);
                    isDirty = true;
                }
            } else {
                // tried to modify this attr, but no getter/setter defined
                console.error("patch error, missing accessor(s)", attrDef);
            }
        }
    });

    return isDirty;
};

const getModelObjectAs = function (
    req,
    modelClass,
    objectId,
    selectAttributes,
    includeAttributes
) {
    // returns a promise
    var q = new Parse.Query(modelClass);

    // select
    if (selectAttributes) {
        if (Array.isArray(selectAttributes)) {
            q.select(selectAttributes);
        } else {
            q.select([selectAttributes]);
        }
    }

    // include
    if (includeAttributes) {
        if (Array.isArray(includeAttributes)) {
            _.each(includeAttributes, function (includeAttr) {
                q.include(includeAttr);
            });
        } else {
            q.include(includeAttributes);
        }
    }

    // get it
    // return getAs(null, q, objectId); // TODO: Investigate issue with request / master key
    return getAs(req, q, objectId); //
};

// UPDATING PARSE OBJECTS
const updateParseObject = async function (
    className,
    objectId,
    operationType,
    attributeName,
    attributeType,
    attributeValue
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // attributePointerClassName
) {
    // updates and saves a value on a parse object
    // intended to be used from a delay bull job

    const validClassNames = [
        "TBAffiliate",
        "TB_AffiliateInfo",
        "TBAthlete",
        "TBAthletePreferences",
        "TBWorkoutResult",
        "TBFriend",
        "TBComment",
        "TBFistbump",
        "TBScheduledWorkout",
        "TBFeedItem",
        "TBWhiteboard",
        "GymGroupPosts",
    ];

    let theObject;

    try {
        // object to update info is req'd
        assertTrue(
            validClassNames.indexOf(className) !== -1,
            "Unsupported class."
        );
        assertTrue(objectId && objectId.length > 0, "Missing objectId.");

        // attribute to update is req'd
        assertDefined(attributeName, "Missing attribute name.");

        // create or fetch the object to update
        const aClass = Parse.Object.extend(className);

        if (operationType === "objectUpdate") {
            // must fetch this object prior to updating...
            theObject = await getModelObjectAs(
                null,
                aClass,
                objectId,
                attributeName
            );
        } else {
            // don't need the actual object, just create a stub to update...
            theObject = new aClass();
            theObject.id = objectId;
        }

        assertDefined(theObject, "No object to update.");

        // several operationTypes are supported:
        // increment, add* (to an array), remove* (from an array), update (default)
        switch (operationType) {
            case "objectUpdate": {
                const obj = theObject.get(attributeName) || {};
                const newObj = _.extend(obj, attributeValue);
                theObject.set(attributeName, newObj);
                break;
            }

            case "increment": {
                theObject.increment(attributeName, attributeValue);
                break;
            }

            case "add":
                theObject.add(attributeName, attributeValue);
                break;

            case "addAll":
                theObject.addAll(attributeName, attributeValue);
                break;

            case "addAllUnique":
                theObject.addAllUnique(attributeName, attributeValue);
                break;

            case "addUnique":
                theObject.addUnique(attributeName, attributeValue);
                break;

            case "remove":
                theObject.remove(attributeName, attributeValue);
                break;

            case "removeAll":
                theObject.removeAll(attributeName, attributeValue);
                break;

            case "update":
            default: {
                if (isDefined(attributeValue)) {
                    // does attributeValue need to be converted?
                    // some values (like Dates) don't come through Bull very well
                    // the new value could be a pointer to another parse object
                    // if attributeType is a supported class name, we assume so

                    switch (attributeType) {
                        case "TBAffiliate":
                        case "TBAthlete":
                        case "TBAthletePreferences":
                        case "TBWorkoutResult":
                        case "TBFriend":
                        case "TBComment":
                        case "TBFistbump":
                        case "TBLibraryWorkout":
                        case "TBScheduledWorkout":
                        case "TBFeedItem":
                        case "GymGroupPosts":
                        case "TBWhiteboard": {
                            const anotherClass =
                                Parse.Object.extend(attributeType);
                            const anotherPFO = new anotherClass();
                            anotherPFO.id = attributeValue;

                            attributeValue = anotherPFO;

                            break;
                        }

                        case "date":
                            attributeValue = moment(attributeValue).toDate();
                            break;
                        default:
                            // do nothing
                            break;
                    }

                    // update the value
                    theObject.set(attributeName, attributeValue);
                } else {
                    // new value is null, unset the attribute
                    theObject.unset(attributeName);
                }

                break;
            }
        }

        // Save the object
        await saveAs(null, theObject);
    } catch (error) {
        // catch (and ignore) 'object not found' errors, other errors pass through.
        if (error && error.code === Parse.Error.OBJECT_NOT_FOUND) {
            return;
        } else {
            throw error;
        }
    }
};

const deleteParseObject = function (className, objectId) {
    // deletes a parse object
    // intended to be used from a delay bull job

    var validClassNames = [
        "_Session",
        "_Installation",
        "TBWorkoutResult",
        "TBFriend",
        "TBComment",
        "TBFistbump",
        "TBBarbellLiftPRs",
        "TBAthlete",
        "TBAthleteAccess",
        "TB_IdentityAthlete",
        "TB_AthleteInfo",
        "GymGroupPosts",
    ];

    return Promise.resolve()

        .then(function () {
            // object to update
            assertTrue(
                validClassNames.indexOf(className) !== -1,
                'Not permitted to delete objects of type "' + className + '"'
            );
            assertDefined(objectId);
        })

        .then(function () {
            // create a stub of the object to delete.
            var aClass = Parse.Object.extend(className);

            if (className === "_Session") {
                aClass = Parse.Session;
            } else if (className === "_Installation") {
                aClass = Parse.Installation;
            }

            var pfo = new aClass();
            pfo.id = objectId;

            return destroyAs(null, pfo);
        })

        .then(function () {
            return Promise.resolve(
                "Deleted: " + className + " [" + objectId + "]"
            );
        })

        .catch(function (error) {
            // if it failed because the object wasn't found, then ignore the error
            // the object was already deleted
            if (error.code === Parse.Error.OBJECT_NOT_FOUND) {
                return Promise.resolve(
                    "Object not found for delete: " +
                        className +
                        " [" +
                        objectId +
                        "]"
                );
            }

            return Promise.reject(error);
        });
};

exports.queueJobsToDeleteParseObjects = function (pfos) {
    if (!pfos) return Promise.resolve();

    // pfos do not need to be fetched
    var promises = _.map(pfos, function (pfo) {
        return _jobQueue.add(
            {
                type: _sw_constants.DELAY.DELETE_OBJECT,
                className: pfo.className,
                objectId: pfo.id,
            },
            { priority: _sw_constants.DELAY_PRIORITY.NORMAL }
        );
    });

    return Promise.all(promises);
};

const deleteParseData = async function (pfos) {
    try {
        if (pfos && pfos.length > 0) {
            await destroyAllAs(null, pfos);
        } else {
            return;
        }
    } catch (e) {
        console.error("Error deleting objects:", e);
        throw e;
    }
};

// QUERIES

//
//
//         FILTER / SORT
//
//
exports.filterByDateInt = function (query, dateIntAttribute, queryParams) {
    // let isFiltered = false;

    const parseIntParam = (param) => parseInt(queryParams[param], 10);
    const addDaysToMoment = (days) => moment().add(days, "days");
    const subtractDaysFromMoment = (days) => moment().subtract(days, "days");
    const setQueryRange = (start, end) => {
        query.greaterThanOrEqualTo(dateIntAttribute, start);
        query.lessThanOrEqualTo(dateIntAttribute, end);
    };

    // filter by week?
    const weekStartInt = parseIntParam("week");
    if (isDefined(weekStartInt) && !isNaN(weekStartInt)) {
        const weekStartMoment = integerAsMoment(weekStartInt);
        setQueryRange(
            weekStartInt,
            momentAsInteger(moment(weekStartMoment).add(6, "days"))
        );
        // isFiltered = true;
    }

    // trailing date range to today
    const trailingInt = parseIntParam("trailing");
    if (isDefined(trailingInt) && !isNaN(trailingInt)) {
        const mom = subtractDaysFromMoment(trailingInt);
        setQueryRange(momentAsInteger(mom), momentAsInteger(moment()));
        // isFiltered = true;
    }

    const futureInt = parseIntParam("future");
    if (isDefined(futureInt) && !isNaN(futureInt)) {
        const mom = addDaysToMoment(futureInt);
        setQueryRange(momentAsInteger(moment()), momentAsInteger(mom));
        // isFiltered = true;
    }

    // date range
    const fromDateInt = parseIntParam("fromDate");
    const toDateInt = parseIntParam("toDate");
    if (
        isDefined(fromDateInt) &&
        !isNaN(fromDateInt) &&
        isDefined(toDateInt) &&
        !isNaN(toDateInt)
    ) {
        setQueryRange(fromDateInt, toDateInt);
        // isFiltered = true;
    }

    // exact date
    const dateInt = parseIntParam("date");
    if (isDefined(dateInt) && !isNaN(dateInt)) {
        query.equalTo(dateIntAttribute, dateInt);
        // isFiltered = true;
    }

    // Uncomment if needed, to filter by today's date
    // if (!isFiltered) {
    //     query.equalTo(dateIntAttribute, utils.dateIntegerToday());
    // }
};

exports.filterByDate = function (query, queryParams) {
    // date range (inclusive)
    var fromDateInt = parseInt(queryParams.fromDateInt, 10);
    var toDateInt = parseInt(queryParams.toDateInt, 10);
    if (
        isDefined(fromDateInt) &&
        !isNaN(fromDateInt) &&
        isDefined(toDateInt) &&
        !isNaN(toDateInt)
    ) {
        // a little protection...
        var daysDiff = exports.daysBetweenDateIntegers(fromDateInt, toDateInt);
        if (daysDiff > 32) {
            toDateInt = exports.incrementDateInteger(fromDateInt, 30);
        }

        const fromDate = integerAsMoment(fromDateInt);
        const toDate = integerAsMoment(toDateInt).add(1, "days");

        query.greaterThanOrEqualTo("date", fromDate.toDate());
        query.lessThanOrEqualTo("date", toDate.toDate());
    }

    // trailing date range to today
    if (isDefined(queryParams.trailing)) {
        var trailingDays = Math.min(90, parseInt(queryParams.trailing));
        var date = moment().subtract(trailingDays, "days").toDate();
        query.greaterThanOrEqualTo("date", date);
    }

    // exact date
    if (isDefined(queryParams.date)) {
        const mom = integerAsMoment(queryParams.date);
        query.greaterThanOrEqualTo("date", mom.toDate());
        query.lessThan("date", mom.add(1, "days").toDate());
    }
};

exports.filterByGender = function (query, queryParams) {
    // filter by gender?
    var gender = "all";
    if (isDefined(queryParams.gender)) {
        gender = queryParams.gender.toLowerCase();
    }

    if (gender !== "both" && gender !== "all") {
        query.equalTo(
            "gender",
            _sw_models.TBAthlete.GENDERS.getByKey(gender).id
        );
    }
};

exports.filterByAthlete = function (query, attributeKey, athleteIds) {
    // athletes filter
    if (isDefined(athleteIds)) {
        var aths = _.map(athleteIds, function (athId) {
            return _sw_models.TBAthlete.createWithoutData(athId);
        });
        query.containedIn(attributeKey, aths);
    }
};

exports.filterByAffiliate = function (query, attributeKey, affiliateIds) {
    // affiliate filter
    if (isDefined(affiliateIds)) {
        var affs = _.map(affiliateIds, function (affId) {
            return _sw_models.TBAffiliate.createWithoutData(affId);
        });
        query.containedIn(attributeKey, affs);
    }
};

exports.filterByBarbellLift = function (query, attributeKey, queryParams) {
    if (queryParams.barbell) {
        query.equalTo(
            attributeKey,
            _sw_models.TBBarbellLift.createWithoutData(queryParams.barbell)
        );
    }
};

exports.filterByLibraryWorkout = function (query, attributeKey, queryParams) {
    if (queryParams.library) {
        query.equalTo(
            attributeKey,
            _sw_models.TBLibraryWorkout.createWithoutData(queryParams.library)
        );
    }
};

exports.filterByLibraryWorkoutType = function (
    query,
    attributeKey,
    queryParams,
    affId
) {
    // affId is required only for custom lw benchmarks

    const libTypeName = queryParams.libraryType;
    if (!libTypeName) return;

    const libType =
        _sw_models.TBLibraryWorkout.libraryTypeFromName(libTypeName);

    if (isDefined(libType)) {
        query.equalTo(attributeKey, libType);

        // if a gym benchmark lw, add the affiliate as a query param
        // prevents a weird case when the athlete has changed affiliates
        // we don't want to fetch WRs from the "old" affiliate
        if (affId && libType === _sw_constants.TBWorkoutLibraryType.Affiliate) {
            query.equalTo(
                "affiliate",
                _sw_models.TBAffiliate.createWithoutData(affId)
            );
        }
    }
};

exports.sortByAttribute = function (query, queryParams) {
    var ascendingAttr = queryParams.ascending;
    if (isDefined(ascendingAttr)) {
        query.ascending(ascendingAttr);
    }
    var descendingAttr = queryParams.descending;
    if (isDefined(descendingAttr)) {
        query.descending(descendingAttr);
    }
};

exports.addSortOrderToResultQuery = function (q, resultType) {
    switch (resultType) {
        case 0: // time, smaller is better
            q.ascending("bestResult");
            break;
        case 3: // load, bigger is better
            q.descending("bestResultLbs");
            break;
        default: // others, bigger is better
            q.descending("bestResult");
            break;
    }
};

//
//
//         NEW DB METHODS
//
//

// Query and Object "AS" functions

// first parameter is (request | null) ---- if req, then find a sessionToken, if null (or no token found on req), then use master
// all return promises

/* on Parse.Query */

const parseOptionsForRequest = function (req) {
    // Requests will have a sessionToken on them somewhere.
    // Requests from the node app will have req.session.token
    // Requests from Cloud Code will have req.user.getSessionToken()
    // This function hides this ugliness
    // if no session token can be found, will fall back to "master"

    // if(req) return getSessionTokenParameter(req);
    // else return _sw_constants.useMasterKeyOption;
    return req
        ? getSessionTokenParameter(req)
        : _sw_constants.useMasterKeyOption;
};

/**
 * Executes a query with optional secondary read preference.
 *
 * @param {Object} req - The request object.
 * @param {Object} query - The query object to execute.
 * @param {boolean} [useSecondary=false] - Whether to use secondary read preference.
 * @returns {Promise} - A promise that resolves with the query results.
 */
const findAs = (req, query, useSecondary = false) => {
    if (!query) return Promise.reject(new Error("Query is required."));
    if (useSecondary) query.readPreference("secondary");
    return Promise.resolve(query.find(parseOptionsForRequest(req)));
};
const findAllAs = async function (req, query, useSecondary = false) {
    let skip = 0;
    const pageSize = 500;
    let batch;
    const results = [];

    do {
        query.skip(skip);
        query.limit(pageSize);
        batch = await findAs(req, query, useSecondary);

        results.push(...batch);
        skip += pageSize;
    } while (batch.length === pageSize);
    return Promise.resolve(results);
};
const firstAs = (req, query) => {
    if (!query) return Promise.reject(new Error("Query is required."));
    return Promise.resolve(query.first(parseOptionsForRequest(req)));
};
const getAs = async function (req, query, objectId) {
    if (!query) {
        console.error("Query is required.");
        throw new Error("Query is required.");
    }
    if (!objectId) {
        console.error("ID is required.");
        throw new Error("ID is required.");
    }
    const options = parseOptionsForRequest(req);
    try {
        return await query.get(objectId, options);
    } catch (error) {
        console.error("Error executing query:", error);
        throw error;
    }
};

exports.countAs = function (req, query) {
    if (!query) return Promise.reject(new Error("Query is required."));
    return Promise.resolve(query.count(parseOptionsForRequest(req)));
};
exports.distinctAs = function (req, query, attribute) {
    if (!(query && attribute))
        return Promise.reject(new Error("Missing parameters is required."));
    return Promise.resolve(
        query.distinct(attribute, parseOptionsForRequest(req))
    );
};

/* on Parse.Object */
exports.fetchAs = function (req, pfo) {
    if (!pfo) return Promise.resolve();
    return Promise.resolve(pfo.fetch(parseOptionsForRequest(req)));
};

const saveAllAs = function (req, objsArray) {
    // make sure this is an array with at least one pfo in it...
    if (!Array.isArray(objsArray)) return Promise.resolve();

    var promises = _.map(objsArray, function (obj) {
        return saveAs(req, obj);
    });

    return Promise.all(promises);
};

const destroyAs = (req, pfo) => {
    if (!pfo) return Promise.resolve();

    const requestOptionsObject = parseOptionsForRequest(req);

    if (req && req.context) {
        requestOptionsObject.context = req.context;
    }

    return Promise.resolve(pfo.destroy(requestOptionsObject));
};

const destroyAllAs = function (req, objsArray) {
    var BATCH_SIZE = 50;

    // if empty, we are done
    if (objsArray.length === 0) {
        return Promise.resolve();
    }

    // destroy the first 'batch size' objects
    var objsToDestroy = objsArray.slice(0, BATCH_SIZE);
    var objsRemaining = objsArray.slice(BATCH_SIZE);

    return Promise.resolve().then(() => {
        return (
            Parse.Object.destroyAll(objsToDestroy, parseOptionsForRequest(req))

                // recurse, if necessary
                .then(function () {
                    return objsRemaining.length > 0
                        ? destroyAllAs(req, objsRemaining)
                        : Promise.resolve();
                })
        );
    });
};

/* abstract */
const createWithoutDataIfNecessary = function (modelClass, modelObjectOrID) {
    // given an ID, return a Parse Object.
    // If already a Parse Object, just return
    return typeof modelObjectOrID === "string"
        ? modelClass.createWithoutData(modelObjectOrID)
        : modelObjectOrID;
};

// SESSION TOKENS
const getSessionTokenParameter = function (req) {
    // Requests will have a sessionToken on them somewhere.
    // Requests from the node app will have req.session.token
    // Requests from Cloud Code will have req.user.getSessionToken()
    // This function hides this ugliness
    // if no session token can be found, will fall back to "master"

    var token = null;
    if (req.session) {
        token = req.session.token;
    } else if (req.user) {
        token = req.user.getSessionToken();
    }

    // if we can't find a token, bail out and use the masterKey
    // not pretty, but at least won't fail :(
    return token ? { sessionToken: token } : _sw_constants.useMasterKeyOption;
};

exports.removeItemsByRegexList = function (itemsList, regexList = []) {
    return _.select(itemsList, (item) => {
        return !_.some(regexList, (regex) => {
            return regex.test(item);
        });
    });
};

/**
 * Saves a Parse file object with options derived from the request.
 *
 * @param {Object} req - The request object.
 * @param {Object} parseFileObject - The Parse file object to save.
 * @returns {Promise} - A promise that resolves with the saved file object.
 */
const saveAs = async (req, parseFileObject) => {
    if (!parseFileObject) return;
    return await parseFileObject.save(null, parseOptionsForRequest(req));
};

const isDefined = (value) => typeof value !== "undefined" && value !== null;
const logObj = (label, obj) => console.log(label, JSON.stringify(obj, null, 4));

const removeDuplicates = (arr) => {
    return arr.filter((item, index) => arr.indexOf(item) === index);
};

const parentDirectory = path.resolve(__dirname, "..");

const pushNotificationConfig = {
    android: {
        // senderId: process.env.GCM_SENDER_ID || '...',
        senderId: process.env.FCM_SENDER_ID || "...",
        apiKey: process.env.FCM_API_KEY || "...",
    },

    // NOTE: Updates for SUGWOD-7558
    // android: {
    //     senderId: process.env.FCM_SENDER_ID || "Sender_id_string",
    //     firebaseServiceAccount: firebaseConfigJSON,
    //     fcmEnableLegacyHttpTransport: true,
    //     resolveUnhandledClientError: true
    // },

    // NOTE: try to arrange .p12 files in descending order of expiry date and follow this specific naming convention for .p12 files
    ios: [
        // NON-PRODUCTION CERTIFICATES ****************************************************
        {
            pfx: parentDirectory + "/cert/aps_prod_expires_02_16_2026.p12",
            topic: process.env.IOS_BUNDLE_ID || "",
            production: false,
        },
        {
            pfx:
                parentDirectory +
                "/cert/aps_prod_projecthockey_expires_02_14_2026.p12",
            topic: process.env.IOS_PROJECT_HOCKEY_BUNDLE_ID || "",
            production: false, // TODO: Look into why there isn't a production true for this one
        },
        {
            pfx:
                parentDirectory +
                "/cert/aps_prod_mayhem_expires_02_14_2026.p12",
            topic: process.env.IOS_MAYHEM_BUNDLE_ID || "",
            production: false,
        },

        // PRODUCTION CERTIFICATES ****************************************************
        {
            pfx: parentDirectory + "/cert/aps_prod_expires_02_16_2026.p12",
            topic: process.env.IOS_BUNDLE_ID || "", // SUGARWOD APP
            production: true,
        },
        {
            pfx:
                parentDirectory +
                "/cert/aps_prod_mayhem_expires_02_14_2026.p12",
            topic: process.env.IOS_MAYHEM_BUNDLE_ID || "", // MAYHEM APP
            production: true,
        },
        {
            pfx:
                parentDirectory + "/cert/aps_prod_ncfit_expires_02_14_2026.p12",
            topic: process.env.IOS_NCFIT_BUNDLE_ID || "", // TRAIN HARD APP
            production: true,
        },
        {
            // TODO: This causes the app to crash the cert needs to be recreated using a newer version of the cert tool
            pfx: parentDirectory + "/cert/aps_prod_prvn_expires_05_05_2026.p12",
            topic: process.env.IOS_PRVN_FITNESS_BUNDLE_ID || "", // PRVN_FITNESS APP
            production: true,
        },
        {
            pfx:
                parentDirectory +
                "/cert/aps_prod_projecthockey_expires_02_14_2026.p12",
            topic:
                process.env.IOS_PROJECT_HOCKEY_BUNDLE_ID ||
                "com.sugarwod.branded.projecthockey", // PROJECT HOCKEY APP
            production: true,
        },
    ],
};

const engineeringTeamEmails = [
    "ahmet.reiz@daxko.com",
    "austin.black@daxko.com",
    "disha.tyagi@daxko.com",
    "dikshant.kulshrestha@daxko.com",
    "gaurav.sharma@daxko.com",
    "jordan.pflederer@daxko.com",
    "kevin.wilkinson@daxko.com",
    "michael.nock@daxko.com",
    "Rakesh.bisht@daxko.com",
    "robert.neal@daxko.com",
    "robina.khan@daxko.com",
    "salman.khan@daxko.com",
    "scott.harris@daxko.com",
    "shashwat.tripathi@daxko.com",
    "sudhanshu.tripathi@daxko.com",
];
exports.getMovements = function (movementIds) {
    return _.map(movementIds, function (moveId) {
        return _sw_models.TBMovement.createWithoutData(moveId);
    });
};

exports.isValid = function (param) {
    assertDefined(param, "Missing required parameters.");
};

exports.isValidParameters = function (param1, param2) {
    assertAllDefined([param1, param2], "Missing required parameters.");
};

exports.checkAffiliateActiveSubscription = function (subscribingAffiliate) {
    assertFalse(
        subscribingAffiliate.getHasPackageA(),
        "This gym already has an active subscription."
    );
};

exports.createTier = function (
    minAthletes,
    maxAthletes,
    priceLabel,
    priceValueCents,
    planName,
    planId
) {
    return new _sw_models.TB_SubscriptionTier.newObject(
        minAthletes,
        maxAthletes,
        priceLabel,
        priceValueCents,
        planName,
        planId
    );
};

const addNoIndexToResponseHeader = (req, res, next) => {
    res.setHeader("X-Robots-Tag", "noindex");
    next();
};

//Returns true if the object is empty, false otherwise
const isEmptyObject = function (obj) {
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
};

const MAX_RETRIES = 3;
const RETRY_DELAY = 1000;
async function retryOperation(operation, retries = MAX_RETRIES) {
    try {
        return await operation();
    } catch (error) {
        if (retries > 0) {
            console.log(`Retrying operation. ${retries} retries left.`);
            await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY));
            return retryOperation(operation, retries - 1);
        } else {
            throw new Error(
                `Max retries exceeded. Unable to complete operation ${operation}.`
            );
        }
    }
}

async function getAffiliate(affiliateId) {
    const query = new Parse.Query(_sw_models.TBAffiliate);
    try {
        const result = await getAs(null, query, affiliateId);
        const name = result.get("name");
        return name;
    } catch (error) {
        console.error("Error fetching object:", error);
        throw error;
    }
}
const getAffiliates = async (affiliateIds) => {
    const query = new Parse.Query(_sw_models.TBAffiliate);
    query.containedIn("objectId", affiliateIds);
    query.select("name");
    try {
        return await findAs(null, query);
    } catch (error) {
        console.error(`Error fetching affiliates: ${error}`);
        throw error;
    }
};
const isValidSlug = (slug, message = "") => {
    const regex = /^(?!-)([a-z0-9]+(-[a-z0-9]+)*)?(?<!-)$/;
    assertTrue(regex.test(slug) && slug.length > 0, message || "Invalid slug.");
};

/**
 * Accepts an affiliate id, a user id, and a permission mask, and returns a Parse ACL object.
 * Example usage:
 * ```javascript
 * const acl = createACL(affiliate, user, ACL_ROLE_PERMISSIONS.PUBLIC_READ + ACL_ROLE_PERMISSIONS.USER_READ + ACL_ROLE_PERMISSIONS.USER_WRITE);
 * ```
 * @param {TBAffiliate|string} affiliate
 * @param {ParseUser|string} user
 * @param {number} permission 8 bit integer, like chown.
 * @returns
 */
function createACL(affiliate, user, permission, existingACL) {
    // acl
    const acl = existingACL || new Parse.ACL();

    const affiliateId = affiliate
        ? typeof affiliate === "string"
            ? affiliate
            : affiliate.id
        : undefined;
    const userId = user
        ? typeof user === "string"
            ? user
            : user.id
        : undefined;

    const maxPermission = Object.values(ACL_ROLE_PERMISSIONS).reduce(
        (acc, val) => acc + val,
        0
    );

    if (isNaN(permission) || permission < 0 || permission > maxPermission) {
        throw new Error(
            `Invalid ACL permission. Must be between 0 and ${maxPermission}.`
        );
    }

    const isPublicRead = !!(permission & ACL_ROLE_PERMISSIONS.PUBLIC_READ);
    const isPublicWrite = !!(permission & ACL_ROLE_PERMISSIONS.PUBLIC_WRITE);

    const isUserRead = !!(permission & ACL_ROLE_PERMISSIONS.USER_READ);
    const isUserWrite = !!(permission & ACL_ROLE_PERMISSIONS.USER_WRITE);

    const isAthleteRead = !!(permission & ACL_ROLE_PERMISSIONS.ATHLETE_READ);
    const isAthleteWrite = !!(permission & ACL_ROLE_PERMISSIONS.ATHLETE_WRITE);

    const isStaffRead = !!(permission & ACL_ROLE_PERMISSIONS.STAFF_READ);
    const isStaffWrite = !!(permission & ACL_ROLE_PERMISSIONS.STAFF_WRITE);

    const isFriendshipRead = !!(
        permission & ACL_ROLE_PERMISSIONS.FRIENDSHIP_READ
    );
    const isFriendshipWrite = !!(
        permission & ACL_ROLE_PERMISSIONS.FRIENDSHIP_WRITE
    );

    if (userId) {
        acl.setReadAccess(user.id, isUserRead);
        acl.setWriteAccess(user.id, isUserWrite);
        acl.setRoleReadAccess(`friendship-${userId}`, isFriendshipRead);
        acl.setRoleWriteAccess(`friendship-${userId}`, isFriendshipWrite);
    }

    if (affiliateId) {
        acl.setRoleReadAccess(`athlete-${affiliateId}`, isAthleteRead);
        acl.setRoleWriteAccess(`athlete-${affiliateId}`, isAthleteWrite);
        acl.setRoleReadAccess(`staff-${affiliateId}`, isStaffRead);
        acl.setRoleWriteAccess(`staff-${affiliateId}`, isStaffWrite);
    }

    // Sysmod/sysadmin always
    acl.setRoleReadAccess("sysmod", true);
    acl.setRoleWriteAccess("sysmod", true);
    acl.setRoleReadAccess("sysadmin", true);
    acl.setRoleWriteAccess("sysadmin", true);

    acl.setPublicReadAccess(isPublicRead);
    acl.setPublicWriteAccess(isPublicWrite);

    return acl;
}

module.exports.createACL = createACL;

module.exports.getAffiliate = getAffiliate;
module.exports.getAffiliates = getAffiliates;

module.exports.asJSONIfDefined = asJSONIfDefined;
module.exports.assertAllDefined = assertAllDefined;
module.exports.assertDefined = assertDefined;
module.exports.assertTrue = assertTrue;
module.exports.createBase64Attachment = createBase64Attachment;
module.exports.createWithoutDataIfNecessary = createWithoutDataIfNecessary;
module.exports.dateAsInteger = dateAsInteger;
module.exports.deleteParseObject = deleteParseObject;
module.exports.findAllAs = findAllAs;
module.exports.firstAs = firstAs;
module.exports.getIdIfDefined = getIdIfDefined;
module.exports.getModelObjectAs = getModelObjectAs;
module.exports.getURLIfDefined = getURLIfDefined;
module.exports.isDefined = isDefined;
module.exports.logObj = logObj;
module.exports.numberWithCommas = numberWithCommas;
module.exports.saveAllAs = saveAllAs;
module.exports.saveAs = saveAs;
module.exports.getAs = getAs;
module.exports.updateParseObject = updateParseObject;
module.exports.assertType_Object = assertType_Object;
module.exports.assertIsValidObjectId = assertIsValidObjectId;
module.exports.assertType_String = assertType_String;
module.exports.destroyAs = destroyAs;
module.exports.destroyAllAs = destroyAllAs;
module.exports.withHttpIfNecessary = withHttpIfNecessary;
module.exports.assertType_Array = assertType_Array;
module.exports.findAs = findAs;
module.exports.integerAsMoment = integerAsMoment;
module.exports.momentAsInteger = momentAsInteger;
module.exports.parseOptionsForRequest = parseOptionsForRequest;
module.exports.getSessionTokenParameter = getSessionTokenParameter;
module.exports.pushNotificationConfig = pushNotificationConfig;
module.exports.engineeringTeamEmails = engineeringTeamEmails;
module.exports.addNoIndexToResponseHeader = addNoIndexToResponseHeader;
module.exports.assertFalse = assertFalse;
module.exports.removeDuplicates = removeDuplicates;
module.exports.isEmptyObject = isEmptyObject;
module.exports.deleteParseData = deleteParseData;
module.exports.formatDateFromInt = formatDateFromInt;
module.exports.retryOperation = retryOperation;
module.exports.isValidSlug = isValidSlug;
